import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model"

export class CreateCasoRequest extends CreateKeyValueRequest
{
  public caratula!: string
  public activo!: boolean
  public fechaComienzo!: Date
  public fechaFinalizacion!: Date
  public idTipoCaso!: number
  public idEstadoCaso!: number

}
